import {
  FileFragment,
  GifInput,
  MessageThreadFragment,
  MessageThreadType,
  RelatedMessageThreadFragment,
  TaskPriorityType,
  TaskStatusType,
} from "gql/graphql";
import { TaskDueDateOption } from "modules/utils/Constants";

export interface IQuotedMessage {
  id: string;
  messageId: string;
  messageThreadId: string;
  parentMessageId: string;
  parentMessageThreadId: string;
  createdUserId: string;
  createTime: string;
  canAccessMessageThread: boolean;
  quillDelta?: string | null;
  text?: string | null;
  actionText?: string | null;
  locale?: string | null;
  localizedText?: string | null;
  file?: FileFragment | null;
}

export interface IMessage {
  messageId: string;
  updateTime: string;
  text: string | null;
  delta: string | null;
  distributionGroupIdList: string[];
  calloutUserIdList: string[];
  tagIdList: string[];
  gifList: GifInput[];
  relatedMessageThread?: IRelatedMessageThread | null;
  quotedMessageList: IQuotedMessage[] | undefined;
}

export interface ITask {
  assignedUserId?: string | null;
  dueDateOption?: TaskDueDateOption;
  dueTime?: string | null;
  priorityType: TaskPriorityType;
  statusType: TaskStatusType;
}

export interface IRelatedMessageThread extends RelatedMessageThreadFragment {
  isRemoved: boolean;
}

export type DRAFT_TYPE = "new-thread" | "reply" | "edit-message";

export interface IMessageThreadDraft extends IMessage {
  id: string;
  messageThreadId: string;

  forwardToMessageThread?: MessageThreadFragment; //used for forward drafts

  draftType?: DRAFT_TYPE;

  //for new threads
  subject?: string | null;
  isLocked?: boolean;
  createMessageUserIdList?: string[];
  isExternal?: boolean;
  type?: MessageThreadType;
  task?: ITask;

  //external
  happycoWorkOrderId?: string | null;
}

export enum FILE_STATE_TYPE {
  QUEUED = "QUEUED",
  UPLOADING = "UPLOADING",
  COMPLETE = "COMPLETE",
  ERROR = "ERROR",
}

export interface IFileInTransit {
  id: string;
  updateTime: string;
  draftId: string;
  byteCount: number;
  uploadedByteCount: number;
  percentage: number;
  name: string;
  extension?: string;
  stateType: FILE_STATE_TYPE;
  contentType: string;
  localPreviewUrl?: string | null;
  previewCloudFrontUrl?: string | null;
  isCopied: boolean; //files that are copied over from other thread should not be 'deleted' via the API when the user cancels the upload
  isCompressed?: boolean;
  isVoiceNote: boolean;
  key: string;
  previewKey?: string | null;
  url?: string;
  sessionId?: string;
}

export type APP_STATE_TYPE =
  | "isTagsExpanded"
  | "expandedParentTagIds"
  | "expandedTagCategoryIds"
  | "expandedInactiveParentTagIds"
  | "isDistributionGroupsExpanded"
  | "isInactiveDistributionGroupsExpanded"
  | "messageThreadIdHasSetNotSeen"
  | "unseenJobCount"

  //use for user toggling between displaying translated/original text on a message
  | "originalTextMessageIdList";

export interface IAppState {
  id: string;
  booleanValue?: boolean;
  stringValue?: string;
  arrayValue?: string[];
  numberValue?: number;
}
